import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos'), { params });
};

const getWhereSedeIdYGestion = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/sede-gestion'), { params });
};

const getWhereSedeIdYGestionIngresosProyectados = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/sede-gestion-ingresos-proyectados'), { params });
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('presupuestos'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`presupuestos/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`presupuestos/${id}`));
};

const show = async (id, { params }) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/transacciones`), { params });
};

const consolidadoGestion = async (id, tipo) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/consolidado?tipo=${tipo}`));
};

const consolidado = async (id, tipo) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/reporte-consolidado?tipo=${tipo}`));
};

const findOneWhereEstimacionSedeIdAndGestionTipo = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/estimacion-sede-gestion-tipo'), { params });
};

const partidas = async (id) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/partidas`));
};

const getPartida = async (id, clasificador) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/partida?clasificador=${clasificador}`));
};

const getEjecucionPresupuestaria = async ({ params }) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/ejecucion-presupuestaria`), { params });
};

const getReporteEjecucionPresupuestaria = async (params) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/reporte-ejecucion-presupuestaria`), {
    params,
    responseType: 'arraybuffer',
  });
};

const agrupadoGestion = async (id, tipo) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/agrupado?tipo=${tipo}`));
};

const agrupadoGestionPorMeses = async (id, tipo) => {
  return await axiosIns.get(obtenerUrl(`presupuestos/${id}/agrupado-por-meses?tipo=${tipo}`));
};

const consolidadosGestion = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/consolidados'), { params });
};

const agrupadosConsolidadosGestion = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/agrupado-consolidados'), { params });
};

const agrupadosPorMesesConsolidadosGestion = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/agrupado-por-meses-consolidados'), { params });
};

const ejecucionPresupuestariaAgrupadaPorCuentas = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('presupuestos/ejecucion-presupuestaria-agrupada-por-cuentas'), { params });
};

export default {
  get,
  store,
  update,
  destroy,
  show,
  consolidado,
  consolidadoGestion,
  partidas,
  getPartida,
  getWhereSedeIdYGestion,
  getWhereSedeIdYGestionIngresosProyectados,
  findOneWhereEstimacionSedeIdAndGestionTipo,
  getEjecucionPresupuestaria,
  getReporteEjecucionPresupuestaria,
  agrupadoGestion,
  agrupadoGestionPorMeses,
  consolidadosGestion,
  agrupadosConsolidadosGestion,
  agrupadosPorMesesConsolidadosGestion,
  ejecucionPresupuestariaAgrupadaPorCuentas,
};
